import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { login } from '../../modules/admin'
import { fetchLatest } from '../../modules/users'
import './home.scss'
import Register from '../register'
import PlayOnly from '../playonly'
import Homenav from '../homenav'
import Party from '../party'
import Class from '../class'
import Member from '../member'
import Checkmember from '../checkmember'
import Checkbook from '../checkbook'
import Checkpartybook from '../checkpartybook'
import Giftcard from '../giftcard'
import { Link } from 'react-router-dom'

const registerText = 'Register User'
const memberText = 'Buy Membership'
const buyPassText = 'Buy Play Only'
const bookPartyText = 'Book Party'
const checkMemberText = 'Check Membership'
const checkBookText = 'Check Booking'
const checkPartyBookText = 'Check Party Booking'
const giftcardText = 'Giftcard'
const classBookText = 'Event Bookings'

class Home extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      openWindow: false
    }
  }

  componentDidMount = () => {
    if (this.props.match.params.membershipId) {
      this.openWindow('member')
    }
    this.props.fetchLatest()
    setTimeout(() => {
      this.props.fetchLatest()
    }, 2000)
  }

  handleChange = (property, { target }) => {
    this.setState({
      [property]: target.value
    })
  }

  openWindow = name => {
    this.setState({
      name: name,
      openWindow: true
    })
  }

  getWindow = () => {
    if (!this.state.openWindow) return

    if (this.state.name === 'register')
      return (
        <Register
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
    else if (this.state.name === 'member')
      return (
        <Member
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
    else if (this.state.name === 'playonly')
      return (
        <PlayOnly
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
    else if (this.state.name === 'party')
      return (
        <Party
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
    else if (this.state.name === 'class')
      return (
        <Class
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
    else if (this.state.name === 'checkmember')
      return (
        <Checkmember
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
    else if (this.state.name === 'checkbook')
      return (
        <Checkbook
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
    // else if (this.state.name === 'checkpartybook')
    //   return (
    //     <Checkpartybook
    //       {...this.props}
    //       closeWindow={this.closeWindow}
    //       closeOpenWindow={this.closeOpenWindow}
    //     />
    //   )
    else if (this.state.name === 'giftcard')
      return (
        <Giftcard
          {...this.props}
          closeWindow={this.closeWindow}
          closeOpenWindow={this.closeOpenWindow}
        />
      )
  }

  closeWindow = () => {
    this.setState({
      name: '',
      openWindow: false
    })
  }

  closeOpenWindow = name => {
    this.setState(
      {
        name: '',
        openWindow: false
      },
      () => {
        this.setState({
          name: name,
          openWindow: true
        })
      }
    )
  }

  render() {
    return (
      <div className="homePage">
        <Homenav />
        {this.getWindow()}
        <div style={{ height: 20 }}></div>
        <div className="homeRow bottomAlign">
          <div
            className={
              'homeButton buttonYellow ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('register')}>
            {registerText}
          </div>
          <div
            className={
              'homeButton buttonGreen ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('checkmember')}>
            {checkMemberText}
          </div>
          <div
            className={
              'homeButton buttonPurple ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('member')}>
            {memberText}
          </div>
          <div
            className={
              'homeButton buttonYellow ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('giftcard')}>
            {giftcardText}
          </div>
          <Link
            className={
              'homeButton buttonGreen ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            to="/menu">
            Edit Menu
          </Link>
        </div>
        <div className="homeRow topAlign">
          <div
            className={
              'homeButton buttonPurple ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('playonly')}>
            {buyPassText}
          </div>
          <div
            className={
              'homeButton buttonYellow ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('party')}>
            {bookPartyText}
          </div>
          <div
            className={
              'homeButton buttonGreen ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('checkbook')}>
            {checkBookText}
          </div>

          <Link
            className={
              'homeButton buttonPurple ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            to="/dashboard/eventBookings">
            {classBookText}
          </Link>
          <Link
            className={
              'homeButton buttonYellow ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            to="/orders">
            Table Orders
          </Link>
          {/* <Link
            className={
              'homeButton buttonPurple ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            to="/dashboard/dateRanges">
            Calendar Date Ranges
          </Link> */}
        </div>
        {/* <div className="homeRow topAlign">
            <div
            className={
              'homeButton buttonGreen ' +
              (!this.state.openWindow ? 'buttonHover' : '')
            }
            onClick={() => this.openWindow('checkpartybook')}>
            {checkPartyBookText}
          </div>
        </div> */}
      </div>
    )
  }
}

const mapStateToProps = ({ users, admin }) => ({
  recentUsers: users.recentUsers,
  requestFailed: admin.requestFailed,
  requestLoading: admin.requestLoading
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      login,
      fetchLatest
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)
